import styled from 'styled-components';


export const TransitionChildren = styled.div`
    &.layoutAppear-appear {
        transition: all 0.7s ease;

        opacity: 0;
        transform: translate3d(0, 40px, 0);
    }

    &.layoutAppear-appear-active {
        opacity: 1;
        transform: translate3d(0, 0, 0);
    }
`;
